// extracted by mini-css-extract-plugin
export default {"truncate":"TableBasicLabel_truncate__DXrwG"};